import React, { useState, useEffect, useReducer } from 'react';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../../_metronic/_partials/controls';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../../_metronic/_helpers';
import Numeric from '../../../../../../../components/Numeric';
import axios, { baseUrl } from '../../../../../../../../redux/my-axios';
import SelectedProduct from '../../../../../../../components/SelectProduct';
import * as columnFormatters from '../../../../../../../components/SelectProduct/List/column-formatters';
import css from './style.module.css';
import DialogBox from '../../../../../../../components/DialogBox';

export const ITEMS_URL = '/items';
function reducer(state, action) {
  switch (action.type) {
    case 'init':
      return { items: action.payload };
    case 'insert':
      return { items: [...state.items, ...action.payload] };
    case 'remove':
      return {
        items: state.items.filter((item) => {
          if (item.productCode !== action.payload) return item;
        }),
      };
    case 'updateprice':
      return {
        items: state.items.map((item) => {
          if (item.productCode === action.payload.id) {
            let temp = parseFloat(
              action.payload.newPrice
                .toString()
                .replace('$', '')
                .replace(',', '')
            );
            const updatedItem = {
              ...item,
              productPricePer: action.payload.newPrice,
              totalPrice:
                Math.round(
                  (temp * item.productQuantity + Number.EPSILON) * 100
                ) / 100,
            };

            return updatedItem;
          }

          return item;
        }),
      };
    case 'updatecount':
      return {
        items: state.items.map((item) => {
          if (item.productCode === action.payload.id) {
            let temp = Number(action.payload.newCount);
            let temp2 = parseFloat(
              item.productPricePer
                .toString()
                .replace('$', '')
                .replace(',', '')
            );
            const updatedItem = {
              ...item,
              productQuantity: action.payload.newCount,
              totalPrice:
                Math.round((temp * temp2 + Number.EPSILON) * 100) / 100,
            };

            return updatedItem;
          }

          return item;
        }),
      };
    default:
      throw new Error();
  }
}

export default function OrderItems(props) {
  const { order, saveOrderItems } = props;
  const [err, setError] = useState('');
  const [msg, setMsg] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [openSelectProducts, setOpenSelectProducts] = useState(false);
  const [openConfirmRemoveItem, setOpenConfirmRemoveItem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, dispatch] = useReducer(reducer, { items: [] });
  const [toRemoveItem, setToRemoveItem] = useState();

  //console.log('ORDERITEMS.Order: ', order);
  const columns = [
    {
      dataField: 'icon',
      text: '',
      sort: false,
      style: {
        width: '65px',
      },
      formatter: columnFormatters.IconColumnFormatter,
    },
    /*     {
      dataField: 'productCode',
      text: 'Code',
      sort: false,
      formatter: columnFormatters.IdColumnFormatter,
    }, */
    {
      dataField: 'name',
      text: 'Name',
      sort: false,
      formatter: columnFormatters.NameColumnFormatter,
    },
    {
      dataField: 'productPricePer',
      text: 'Price',
      sort: false,
      formatter: ProductPriceColumnFormatter,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'productQuantity',
      text: 'Qty',
      sort: false,
      formatter: ProductQuantityColumnFormatter,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '70px',
      },
    },
    {
      dataField: 'totalPrice',
      text: 'Total',
      sort: false,
      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '60px',
        width: '80px',
      },
    },
    {
      dataField: 'action',
      text: '',
      formatter: ActionsColumnFormatter,

      classes: 'text-right pr-0',
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '50px',
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    axios
      .post(ITEMS_URL, order.orderCode, { headers: { action: 'get' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('OrderItems: ', response.data.data);
            setTotalCount(response.data.data.length);
            dispatch({ type: 'init', payload: response.data.data });
            setLoading(false);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [order]);

  useEffect(() => {
    setTotalCount(state.items.length);
    //console.log('RefreshedItems', state.items);
  }, [state]);

  const save = () => {
    setLoading(true);
    axios
      .post(
        ITEMS_URL,
        { orderCode: order.orderCode, items: state.items },
        { headers: { action: 'set' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
            setError('');
            setMsg('Амжилттай хадгаллаа');
            setLoading(false);
            saveOrderItems();
            break;
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('set items: ', response.data.data);
            setError('');
            setMsg(response.data.data);
            setLoading(false);
            saveOrderItems();
            break;
          default:
            var error = response.data.msg.desc;
            setMsg('');
            setError(error);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        setMsg('');
        setError(error);
        setLoading(false);
      });
  };

  const onItemsAddClick = () => {
    setOpenSelectProducts(true);
  };

  const addSelectedItems = (selectedItems) => {
    //console.log('SelectedRows to add: ', selectedItems);
    let temp = [];
    for (let i = 0; i < selectedItems.length; i++) {
      let t = selectedItems[i];
      temp.push({
        productCode: t.productCode,
        name: t.name,
        icon: t.icon,
        productPricePer: '0.00',
        productQuantity: 1,
        totalPrice: '0.00',
        tax: '0.00',
      });
    }

    dispatch({ type: 'insert', payload: temp });
  };

  const removeItem = (item) => {
    // confirm
    setToRemoveItem(item);
    setOpenConfirmRemoveItem(true);
  };
  const remove = () => {
    //console.log('remove', productCode);

    dispatch({ type: 'remove', payload: toRemoveItem.productCode });
  };

  function handleToggleCompletePrice(id, newPrice) {
    dispatch({ type: 'updateprice', payload: { id, newPrice } });
  }
  function handleToggleCompleteQuantity(id, newCount) {
    dispatch({ type: 'updatecount', payload: { id, newCount } });
  }
  const setQuantityVal = (id, quantity) => {
    handleToggleCompleteQuantity(id, quantity);
  };
  const setPriceVal = (id, productPricePer) => {
    handleToggleCompletePrice(id, productPricePer);
  };
  const onChangePriceVal = (id, productPricePer) => {
    handleToggleCompletePrice(id, productPricePer);
  };

  function ProductPriceColumnFormatter(cellContent, row) {
    return (
      <Numeric
        key={`productPricePer_${row.productCode}`}
        name='productPricePer'
        value={row.productPricePer}
        onBlur={(e) => {
          setPriceVal(row.productCode, e);
        }}
        /*         onChange={(e) => {
          onChangePriceVal(row.productCode, e);
        }} */
        className='form-control form-control-sm'
        negative={false}
        prefix=''
      />
    );
  }
  function ProductQuantityColumnFormatter(cellContent, row) {
    return (
      <Numeric
        key={`productQuantity_${row.productCode}`}
        name='productQuantity'
        value={row.productQuantity}
        onBlur={(e) => {
          setQuantityVal(row.productCode, e);
        }}
        className='form-control form-control-sm'
        negative={false}
        type='number'
        decimalScale='0'
        fixedDecimalScale={false}
      />
    );
  }
  function ActionsColumnFormatter(cellContent, row, rowIndex) {
    return (
      <>
        <a
          title='Бүтээгдэхүүний сонголт устгах'
          className='btn btn-icon btn-light btn-hover-danger btn-sm'
          onClick={() => removeItem(row)}
        >
          <span className='svg-icon svg-icon-md svg-icon-danger'>
            <SVG src={toAbsoluteUrl('/media/svg/icons/General/Trash.svg')} />
          </span>
        </a>
      </>
    );
  }

  return (
    <div>
      {err ? (
        <div className='mb-10 alert alert-custom alert-light-danger alert-dismissible'>
          <div className='alert-text font-weight-bold'>{err}</div>
        </div>
      ) : (
        <div></div>
      )}
      {msg ? (
        <div className='mb-10 alert alert-custom alert-light-info alert-dismissible'>
          <div className='alert-text font-weight-bold'>{msg}</div>
        </div>
      ) : (
        <div></div>
      )}
      {openSelectProducts && (
        <SelectedProduct
          openSelectProducts={openSelectProducts}
          setOpenSelectProducts={setOpenSelectProducts}
          addSelectedItems={addSelectedItems}
          //existingItems={entities}
          existingItems={state.items}
        />
      )}
      {toRemoveItem && (
        <DialogBox
          openDialog={openConfirmRemoveItem}
          setOpenDialog={setOpenConfirmRemoveItem}
          icon='question'
          iconColor='danger'
          title='Худалдан авалтын сонголтоос бараа хасах'
          text={`${toRemoveItem.name} #${toRemoveItem.productCode}  гэсэн сонгосон барааг устгахдаа итгэлтэй байна уу?'`}
          buttonOk={false}
          buttonYes={true}
          buttonNo={true}
          onConfirm={remove}
        ></DialogBox>
      )}
      <Card id='orderItemsCard'>
        {loading && <ModalProgressBar />}
        <CardHeader title={`Items - ${totalCount}`}>
          <CardHeaderToolbar>
            <>
              <button
                type='button'
                className='btn btn-secondary ml-2'
                onClick={onItemsAddClick}
              >
                <FormattedMessage id='GENERAL.BUTTON.ADD' />
                {loading && (
                  <span
                    id='orderItemsAdd'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
              <> </>
              <button
                type='button'
                className='btn btn-info ml-2'
                onClick={save}
              >
                <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                {loading && (
                  <span
                    id='orderItemsSave'
                    className='ml-3 spinner spinner-white '
                  ></span>
                )}
              </button>
            </>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/*           {items &&
            items.map((item) => (
              <OrderItem key={`OrderItem${item.productCode}`} value={item} />
            ))} */}
          <BootstrapTable
            wrapperClasses='table-responsive'
            classes='table table-head-custom table-vertical-center overflow-hidden'
            bootstrap4
            bordered={false}
            local
            keyField='productCode'
            //data={entities === null ? [] : entities}
            data={state.items === null ? [] : state.items}
            columns={columns}
            //onTableChange={getHandlerTableChange(setQueryParams)}
            /*  selectRow={getSelectRow({
              entities,
              ids,
              setIds,
            })} */
          >
            {/*  <PleaseWaitMessage entities={entities} />
            <NoRecordsFoundMessage entities={entities} /> */}
            <PleaseWaitMessage entities={state.items} />
            <NoRecordsFoundMessage entities={state.items} />
          </BootstrapTable>
        </CardBody>
      </Card>
    </div>
  );
}
